import React from 'react';
import ParametroRatingService from '../../../../lib/api/parametroRating/parametroRatingService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroRating extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosRating()
    {
       return ParametroRatingService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return ParametroRatingService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosRating}
                enviarExcelParametros={ParametroRatingService.parametroRatingExcelPost}
                deletarExcelParametros={ParametroRatingService.deletarExcelParametros}
                nomeDoArquivo='Parametro Rating'
            ></TemplateParametro>
        );
    }
}

export default ParametroRating